import React from "react";
import { observer } from "mobx-react-lite";
import { Button } from "@ann/web-components";
import ModalBase from "./ModalBase";
import { ModalContent, ActionsContainer } from "./Modal.styled";
import AddUserModalContent from "./AddUserModalContent";
import PendingGranteesList from "./PendingGranteesList";
import CurrentGranteesList from "./CurrentGranteesList";

const AddUserModal = observer(
  ({
    isOpen,
    store,
    resourcesStore,
    onClose,
    onShare,
    onAddToPending,
    onUpdatePendingPermission,
    onRemovePending,
    onUpdateGranteePermission,
    onRemoveGrantee,
    usersList,
    onSearchUsers,
    loadingUsers,
  }) => {
    if (!isOpen) {
      return null;
    }

    return (
      <ModalBase
        isOpen={isOpen}
        onClose={onClose}
        title="Add Users to Customer Success"
      >
        <ModalContent>
          <AddUserModalContent
            selectedUsers={store.selectedUsers}
            selectedPermission={store.selectedPermission}
            currentSelectionType={store.currentSelectionType}
            privileges={resourcesStore}
            onUsersChange={store.setSelectedUsers}
            onPermissionChange={store.setSelectedPermission}
            onAddClick={onAddToPending}
            usersList={usersList}
            onSearchUsers={onSearchUsers}
            loadingUsers={loadingUsers}
          />

          <PendingGranteesList
            pendingGrantees={store.pendingGrantees}
            currentSelectionType={store.currentSelectionType}
            privileges={resourcesStore}
            onUpdatePermission={onUpdatePendingPermission}
            onRemove={onRemovePending}
          />

          <CurrentGranteesList
            shouldShow={store.shouldShowGranteesList}
            grantees={resourcesStore.grantees}
            isLoading={resourcesStore.granteesLoading}
            currentSelectionType={store.currentSelectionType}
            privileges={resourcesStore}
            onUpdatePermission={onUpdateGranteePermission}
            onRemove={onRemoveGrantee}
          />
        </ModalContent>

        <ActionsContainer>
          {store.pendingGrantees.length > 0 && (
            <Button
              label={`Add ${store.pendingGrantees.length} ${
                store.pendingGrantees.length === 1 ? "User" : "Users"
              }`}
              iconLeft="plus"
              size="medium"
              type="primary"
              onClick={onShare}
              disabled={store.isLoadingSharing}
            />
          )}
        </ActionsContainer>
      </ModalBase>
    );
  }
);

export default AddUserModal;
